import React, { useState } from 'react';

import './Uploadexcel.css';
import { addExcelToDatabaseApi } from '../../../Config/api';
import { getCompanyDetails } from '../../../Services/Storage';
import { toast } from 'react-toastify';
import { getRegisterId } from '../../../Config/userId';

const Uploadexcel = ({ show, close }) => {

  const register_id = getRegisterId();
  const [file, setFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const company_details = getCompanyDetails();
  const [errors, setErrors] = useState({});
  const [loader, setloader] = useState(false)


  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    } else {
      setFile(null);
    }
  };

  const closed =()=>{
    close();
    setErrors({});
    setFile(null);
    setDragging(false)
  }
  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const selectedFile = event.dataTransfer.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    } else {
    }
  };

  const handleUpload = async () => {
      const data = {
        "attendance_file": file,
        "register": register_id,
        "company": company_details.company_id,
      }
      try {
        setloader(true)
        const response = await addExcelToDatabaseApi(data);
        if (response) {
          setFile(null);
          close();
          toast.success('Attendance Added Sucessfully!', {
            position: "top-center",
            autoClose: 2000,
            closeButton: false,
            className: 'custom_toast'
          })
        }
      }
      catch (error) {
        const newErrors = {
          response_error: [],
        };
        for (const key in error.response.data.data) {
          if (error.response.data.data.hasOwnProperty(key)) {
            newErrors.response_error.push(`${error.response.data.data[key]}`);
          }
        }
        // toast.error("Failed. Please try again.", {
        //   position: "top-center",
        //   autoClose: 2000,
        //   closeButton: false,
        // });
        setErrors(newErrors);
      } finally {
        setloader(false)
      }

    
  };

  if (!show) return null

  return (
    <div className='uploadexcel-section'>
      <div className='uploadexcel-container'>

        <div className='uploadexcel-container-sub'>
          <div className='uploadexcel-content'>

            <span className='uploadexcel-close' onClick={closed}>&times;</span>
            <p>Upload Excel</p>
            <div
              className={`uploadexcel-upload-area ${dragging ? 'dragging' : ''}`}
              onDragOver={(e) => {
                e.preventDefault();
                setDragging(true);
              }}
              onDragLeave={() => setDragging(false)}
              onDrop={handleDrop}
            >
              {file ? <p>Selected file: {file.name}</p> : <p>Drag and drop your Excel file here, or click to select</p>}
              <input
                type="file"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                id="file-upload"
              />
              <label htmlFor="file-upload" className="uploadexcel-upload-button">Browse Files</label>
            </div>
            {errors.response_error && (
              <div style={{marginBottom:"10px"}} className="registeration-error-view">{errors.response_error}</div>
            )}
            <button className='uploadexcel-upload-btn' onClick={handleUpload} disabled={loader}>

              {loader ?
                <span className='spinner'></span>
                : "Upload"
              }

            </button>

          </div>

        </div>
      </div>
    </div>
  )
}

export default Uploadexcel